"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCompanyCodeFromUrl = void 0;
function getCompanyCodeFromUrl() {
    var _a, _b, _c;
    const parts = window.location.host.split('.');
    const subdomain = parts[0];
    let nodeEnv = (_a = window === null || window === void 0 ? void 0 : window.__ENV) === null || _a === void 0 ? void 0 : _a.NODE_ENV;
    nodeEnv = nodeEnv ? nodeEnv : process.env.NODE_ENV;
    // this has to be written with an if statement because if you just use || then it gets collapsed at build-time since window doesn't exist.
    let defaultCode = (_b = window === null || window === void 0 ? void 0 : window.__ENV) === null || _b === void 0 ? void 0 : _b.REACT_APP_DEFAULT_COMPANY_CODE;
    if (!defaultCode) {
        defaultCode = process.env.REACT_APP_DEFAULT_COMPANY_CODE;
    }
    if (defaultCode) {
        // Putting this back here and going to error on the sly publish script instead so that this works with Docker.
        return defaultCode;
    }
    if (nodeEnv !== 'production' && parts.length <= 2 && !((_c = parts[1]) === null || _c === void 0 ? void 0 : _c.includes('localhost'))) {
        throw new Error('Could not determine company code because the host path is only two parts\n' +
            'and it is expected to be at least three in the format {companyCode}.{app}.{domain+}\n' +
            'You likely need to set REACT_APP_DEFAULT_COMPANY_CODE in your env file');
    }
    return subdomain;
}
exports.getCompanyCodeFromUrl = getCompanyCodeFromUrl;
//# sourceMappingURL=get_company_code_from_url.js.map